import 'bluebird';
import 'webcrypto-shim';
import './dist/custom-modernizr';
//ensures that bluebird and webcrypto-shim are fully loaded before Modernizr is used
export default Modernizr;
